export default __webpack_public_path__ + "static/media/IndigoTrace_StackLogo.ce3fa1cb.svg";